import React from 'react';
import { BarChart2Icon } from 'lucide-react';
interface PorkPrimalRow {
  name: string;
  value: string;
}
const porkPrimalData: PorkPrimalRow[] = [{
  name: 'Carcass',
  value: '$0.99'
}, {
  name: 'Loin',
  value: '$0.93'
}, {
  name: 'Butt',
  value: '$1.14'
}, {
  name: 'Picnic',
  value: '$0.74'
}, {
  name: 'Rib',
  value: '$1.67'
}, {
  name: 'Ham',
  value: '$0.85'
}, {
  name: 'Belly',
  value: '$1.49'
}];
export function PorkPrimalsTable() {
  return <div className="mb-12" data-id="element-272">
      <div className="mb-4" data-id="element-273">
        <div className="flex items-center gap-2 mb-1" data-id="element-274">
          <BarChart2Icon className="w-5 h-5 text-gray-700" data-id="element-275" />
          <h3 className="text-xl font-bold text-gray-900" data-id="element-276">
            Pork Primal Values
          </h3>
        </div>
        <p className="text-sm text-gray-500" data-id="element-277">2026-04-13 – $/lb</p>
      </div>

      <div className="overflow-x-auto" data-id="element-278">
        <table className="w-full text-sm" data-id="element-279">
          <thead data-id="element-280">
            <tr className="border-b border-gray-200" data-id="element-281">
              <th className="text-left py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-500" data-id="element-282">
                Item
              </th>
              <th className="text-right py-3 px-4 text-[11px] font-bold uppercase tracking-wider text-gray-500" data-id="element-283">
                Value
              </th>
            </tr>
          </thead>
          <tbody data-id="element-284">
            {porkPrimalData.map((row, idx) => <tr key={idx} className={`border-b border-gray-100 ${idx === 0 ? 'bg-gray-50 font-semibold' : ''}`} data-id="element-285">
                <td className="py-4 px-4 text-gray-900 font-medium" data-id="element-286">
                  {row.name}
                </td>
                <td className="py-4 px-4 text-right font-semibold text-gray-900" data-id="element-287">
                  {row.value}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Deep Dive Link */}
      <div className="mt-4 flex justify-end" data-id="element-288">
        <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="text-xs font-semibold text-[#002f5f] hover:underline flex items-center gap-1" data-id="element-289">
          View Detailed Analysis
          <BarChart2Icon className="w-3 h-3" data-id="element-290" />
        </a>
      </div>
    </div>;
}